<template>
    <div>
      <p><strong>Teacher:</strong> {{ teacherName }}</p>
      <p><strong>Selected Pay Amount:</strong> ${{ formattedPayment }} <strong>For:</strong> {{ subjectName }}</p>
  
      <form @submit.prevent="submitPayment">
        <div class="mb-3">
          <label for="paymentAmount" class="form-label">Payment Amount</label>
          <input
            v-model.number="amount"
            type="number"
            class="form-control"
            id="paymentAmount"
            required
            min="1"
          />
        </div>
  
        <div class="mb-3">
          <label for="paymentMethod" class="form-label">Payment Method</label>
          <select v-model="method" class="form-control" id="paymentMethod">
            <option value="cash">Cash</option>
            <option value="bank">Bank Transfer</option>
            <option value="online">Online</option>
          </select>
        </div>

        <div class="mb-3">
  <label for="paymentStatus" class="form-label">Payment Status</label>
  <select v-model="paymentStatus" class="form-control" id="paymentStatus">
    <option value="Pending">Pending</option>
    <option value="Paid">Paid</option>
    <option value="Overdue">Overdue</option>
  </select>
</div>

  
        <div class="mb-3">
          <label for="note" class="form-label">Note</label>
          <textarea
            v-model="note"
            class="form-control"
            id="note"
            placeholder="Optional note..."
          ></textarea>
        </div>
  
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary">Save Payment</button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  
  export default {
    props: {
      teacherPayment: {
        type: Number,
        required: true
      },
      teacherId: {
        type: [Number, String],
        required: true
      },
      teacherName: {
        type: String,
        required: true
      },
      subjectName: {
        type: String,
        required: true
      },
      subjectId: {
        type: [Number, String],
        required: true
      }
    },
    data() {
      return {
        amount: this.teacherPayment,
        subject: this.subjectId,
        method: 'cash',
        paymentStatus: 'Paid',
        note: '',
      };
    },
    computed: {
      formattedPayment() {
        return this.formatPayment(this.teacherPayment);
      }
    },
    methods: {
      formatPayment(value) {
        return Number(value).toFixed(2);
      },
  
      validateForm() {
        if (!this.amount || this.amount <= 0) {
          alert('Please enter a valid payment amount.');
          return false;
        }
        if (!this.method) {
          alert('Please select a payment method.');
          return false;
        }
        return true;
      },
  
      getToken() {
        const token = localStorage.getItem('token');
        if (!token) {
          alert('Authorization token is missing.');
          return null;
        }
        return token;
      },
  
      async submitPayment() {
        const instituteId = localStorage.getItem('institute_id');
        const token = this.getToken();
  
        if (!instituteId || !token) {
          alert('Missing institute ID or token.');
          return;
        }
  
        if (!this.validateForm()) {
          return;
        }
  
        const now = new Date();
const payment_date = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;


  
        const payload = {
          institute_id: instituteId,
          teacher_id: this.teacherId,
          subject_id: this.subject,
          payment_date: payment_date,
          paid_amount: parseFloat(this.amount),
          payment_method: this.method,
          payment_status: this.paymentStatus,
          note: this.note.trim()
        };
  
        console.log('Submitting Payment:', payload);
  
        try {
          const response = await axios.post(
            '/save-institute-teacher-payments',
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
              }
            }
          );
  
          console.log('Payment submitted successfully:', response.data);
          alert('Payment submitted successfully!');
          this.resetForm();
        } catch (error) {
          console.error('Error submitting payment:', error);
           // ✅ Display backend error message
    if (error.response && error.response.data && error.response.data.error) {
      alert(`Error: ${error.response.data.error}`);
    } else {
      alert('Failed to submit payment.');
    }
        }
      },
  
      resetForm() {
        this.amount = this.teacherPayment;
        this.method = 'cash';
        this.note = '';
      }
    },
    mounted() {
      console.log('Teacher Payment:', this.teacherPayment);
      console.log('Teacher ID:', this.teacherId);
      console.log('Teacher Name:', this.teacherName);
    }
  };
  </script>
  
  <style scoped lang="scss">
  p {
    font-size: 16px;
    margin-bottom: 10px;
  }
  </style>
  